import { Specialty } from '@quromedical/models';
import { trpc } from 'trpc';

export class SpecialtyApi {
  getAll = async (): Promise<Specialty[]> => {
    return await trpc.client.specialty.getAll.query();
  };
}
